<ng-container >
    <!-- <c-toast-header [closeButton]="closeButton" class="bg-danger text-white">
    <toast-sample-icon />
      <strong>{{ title }}</strong>
    </c-toast-header> -->

    <c-toast-body #toast [cToastClose]="toast.toast ?? undefined" class="bg-success text-white">
      <p class="mb-1">{{message}}</p>
      <ng-content />
      <!-- <c-progress thin [value]="25*(toast.toast?.clock ?? 1)" /> -->
    </c-toast-body>

</ng-container>
